import React, { useState } from "react";
import styles from './ImgComponent.module.css';

export default function ImgComponent({imgObject,maxSize}){

    const [loadedA,setLoadedA] = useState(false);
    const [loadedB,setLoadedB] = useState(false);

    const imgs = (imgObj) => {
        return (
            <>
            <img className={styles.blurred} style={{opacity: `${loadedA? 1 : 0}`, zIndex: 1}} src={imgObj.px20} onLoad={() => setLoadedA(true)} />
            <img style={{opacity: `${loadedB? 1 : 0}`, zIndex: 2, transition: `${loadedB? '0.5s' : '1s'}`}} src={loadedA? imgObj[maxSize] : ''} onLoad={() => setLoadedB(true)} loading={"lazy"}/>
            </>
        )
    }

    return (
        <div className={styles.imgWrapperDiv}>
            {imgObject? imgs(imgObject) : null}
        </div>
    )
}